import React, { useCallback, useEffect, useState } from 'react';
// @mui
import {
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  LinearProgress,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
// hooks
import useMerchant from 'src/hooks/useMerchant';
import useAuth from 'src/hooks/useAuth';
//
import { IconX } from 'src/libraries/icons';

declare global {
  var hbspt: any;
}

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: (flag: boolean) => void;
  region: string;
  portalId: string;
  formId: string;
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '60%',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      width: '100%',
    },
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogTitle-root': {
    margin: theme.spacing(0),
    padding: theme.spacing(2),
  },
}));

const HubspotContactForm: React.FC<Props> = ({
  isModalOpen,
  setIsModalOpen,
  region,
  portalId,
  formId,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const { merchant } = useMerchant();
  const { user } = useAuth();
  const theme = useTheme();

  const onScriptLoad = useCallback(() => {
    if (hbspt) {
      hbspt.forms.create({
        region: region,
        portalId: portalId,
        formId: formId,
        target: '#hubspotForm',
      });
    }
    setIsLoading(false);
  }, [formId, portalId, region]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    script.setAttribute('id', 'hubspot-script')
    script.onload = onScriptLoad;
    document.body.appendChild(script);

    window.addEventListener('message', function (event) {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
        // @ts-ignore
        const formDocument = document.querySelector('[id^="hs-form-iframe-"]').contentDocument;
        console.log('formDocument:', formDocument);
        formDocument.getElementById('email-' + event.data.id).value = user?.email || 'fgfg';
        formDocument.getElementById('firstname-' + event.data.id).value = user?.name;
        formDocument.getElementById('company-' + event.data.id).value = merchant?.name;
      }
    })

    return () => {
      document.body.removeChild(script);
    };
  }, [merchant?.name, onScriptLoad, user?.email, user?.name]);

  return (
    <StyledDialog onClose={() => setIsModalOpen(false)} open={isModalOpen}>
      <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <DialogTitle variant="title1">Contact us</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setIsModalOpen(false)}
          sx={{
            '& svg': {
              color: (theme) => theme.palette.branded.carbon,
            },
          }}
        >
          <IconX color={theme.palette.text.disabled} />
        </IconButton>
      </Stack>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <DialogContent>
          <div id="hubspotForm" />
        </DialogContent>
      )}
    </StyledDialog>
  );
};

export default HubspotContactForm;
